import { render, staticRenderFns } from "./LuminaireList.vue?vue&type=template&id=5fb93621&"
import script from "./LuminaireList.vue?vue&type=script&lang=ts&"
export * from "./LuminaireList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports